import { Component, EventEmitter, Input } from '@angular/core';
import {
    MultiYearAuctionsResource,
    MultiYearCfoAuctionGuiDto
} from 'angular/resources/multi-year-auctions.resource';
import { TimeHelperUtils } from 'angular/utils/time-helper.utils';
import Decimal from 'decimal.js';
import { AuthService } from 'app/_services/auth.service';
import { LoggedInUser } from 'app/custom';
import { Growl } from 'angular/custom/services/growl.service';
import { ErrorHandlerService } from 'angular/custom/services/error-handler.service';

@Component({
    selector: 'pkp-multi-year-capacity-details',
    template: require('./multi-year-capacity-details.component.html'),
    preserveWhitespaces: true
})
export class MultiYearCapacityDetailsComponent {
    private _auctionId: number;
    private auction: MultiYearCfoAuctionGuiDto;

    public loading = true;

    public showAdditionalFees = false;

    public historyLength = window.history.length;

    public zero = new Decimal(0);

    public loggedInUser: LoggedInUser;

    public editedBid: MultiYearCfoBidDto;

    public bidCreated = new EventEmitter();
    formState: 'unchanged' | 'review' | 'submitted';

    constructor(
        private multiYearAuctionResource: MultiYearAuctionsResource,
        private authService: AuthService,
        private growl: Growl,
        private errorHandlerService: ErrorHandlerService
    ) {
        this.authService.userLoginPromise.promise.then(
            (user) => (this.loggedInUser = user)
        );
    }

    get auctionId(): number {
        return this._auctionId;
    }

    @Input() set auctionId(value: number) {
        this._auctionId = value;
        this.loadAuctionData();
    }

    private loadAuctionData() {
        this.loading = true;
        this.multiYearAuctionResource.getAuction(this.auctionId).subscribe(
            (auction) => {
                // order tariffs by duration (largest first)
                auction.tariffsList = auction.tariffsList.sort(
                    (t1, t2) => t2.durationInYears - t1.durationInYears
                );
                this.auction = auction;
                this.loading = false;

                //check if additional fees need to be shown
                this.auction.tariffsList.forEach((t) => {
                    if (t.additionalFee0 || t.additionalFee1) {
                        this.showAdditionalFees = true;
                    }
                });
            },
            (err) =>
                this.errorHandlerService.handle(
                    err,
                    'Auction details could not be loaded.'
                )
        );
    }

    public getAuctionPhase(): string {
        if (
            new Date().valueOf() < this.auction.submissionWindow.start.valueOf()
        ) {
            return 'PUBLISHED';
        }
        if (
            new Date().valueOf() < this.auction.submissionWindow.end.valueOf()
        ) {
            return 'IN_PROGRESS';
        }
        return 'FINISHED';
    }

    public goBack() {
        window.history.back();
    }

    public editBid(bid: MultiYearCfoBidDto) {
        this.editedBid = bid;
    }

    public bidSaved(bid: MultiYearCfoBidDto) {
        this.bidCreated.emit(bid);
    }

    public bidEditCancel() {
        this.editedBid = null;
    }
}
